import LogoSchema from './LogoSchema';

const UniversalSchemas = () => <LogoSchema />;

export default UniversalSchemas;
